export default __webpack_public_path__ + "static/media/kitchen4-afterD-1920w.be124426.avif";